<div class="container-fluid" *ngIf="isLoaded" [@fadeInAnimation]>
  <div class="row">
    <div class="col-xl-1"></div>
    <div class="col-xl-10">
      <div class="card mb-3">
        <div class="card-header">
          <fa-icon [icon]="['fas', 'marker']" size="lg" class="mr-2" [fixedWidth]="true"></fa-icon>Mina meddanden
        </div>
        <div class="card-body">
          <ng-container *ngIf="minaTradar.length">
            <div class="form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <fa-icon [icon]="['fas', 'filter']" [fixedWidth]="true"></fa-icon>
                  </span>
                </div>
                <input [(ngModel)]="filterText" type="text" name="filter" class="form-control rounded-right" placeholder="Filtrera..." (ngModelChange)="applyFilter(newValue)">
              </div>
            </div>
            <div *ngFor="let tradType of tradTypes" class="panel-group">
              <div *ngIf="(minaTradar | filterBy: { 'tradTyp': { 'typ': tradType.typ } }).length" class="panel panel-default">
                <div class="panel-heading">
                  <p class="h5">{{ tradType.namn }}</p>
                </div>
                <div class="panel-body">
                  <div class="table-responsive" *ngIf="(minaTradar | filterBy: patchFilter(tradType.typ)).length">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col" [class.order-active]="order==='arende.galdenar.namn'" (click)="setOrder('arende.galdenar.namn')">
                            <div class="d-flex justify-content-between">
                              Ärende
                              <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                            </div>
                          </th>
                          <th scope="col" [class.order-active]="order==='datumSkapad'" (click)="setOrder('datumSkapad')">
                            <div class="d-flex justify-content-between">
                              Skickad
                              <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                            </div>
                          </th>
                          <th scope="col" [class.order-active]="order==='skapadAvNamn'" (click)="setOrder('skapadAvNamn')">
                            <div class="d-flex justify-content-between">
                              Avsändare
                              <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                            </div>
                          </th>
                          <th scope="col" [class.order-active]="order==='amne'" (click)="setOrder('amne')">
                            <div class="d-flex justify-content-between">
                              Ämne
                              <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                            </div>
                          </th>
                          <th scope="col" [class.order-active]="order==='status.namn'" (click)="setOrder('status.namn')">
                            <div class="d-flex justify-content-between">
                              Status
                              <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ml-2" [flip]="reverse||'vertical'"></fa-icon>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr [id]="t.arende.id" class="link" *ngFor="let t of minaTradar | orderBy: order:reverse:'case-insensitive' | filterBy: patchFilter(tradType.typ)" [routerLink]="['/mina-tradar', t.id]">
                          <td data-name="Ärende">{{ t.arende.galdenar.namn }}</td>
                          <td data-name="Skickad">{{ t.datumSkapad | localizeddate:'shortDate' }} {{ t.datumSkapad | localizeddate:'shortTime' }}</td>
                          <td data-name="Avsändare">{{ t.skapadAvNamn }}</td>
                          <td data-name="Ämne">{{ t.amne }}</td>
                          <td data-name="Status">{{ t.status.namn }}</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <th data-name="Antal" colspan="5">{{ (minaTradar | filterBy: patchFilter(tradType.typ)).length | localizednumber }} st</th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <p class="text-muted" *ngIf="!(minaTradar | filterBy: patchFilter(tradType.typ)).length">Inga träffar</p>
                </div>
              </div>
            </div>
          </ng-container>
          <p class="text-muted" *ngIf="!minaTradar.length">Inga meddelanden</p>
        </div>
      </div>
    </div>
  </div>
</div>
